import appMounted from './chains/appMounted'
import redoGDRP from './chains/redoGDRP'
import removeUserNotAgreedOnGDPRTerms from './chains/removeUserNotAgreedOnGDPRTerms'
import openListUserHeaderAccessMenu from './chains/openListUserHeaderAccessMenu'
import closeListUserHeaderAccessMenu from './chains/closeListUserHeaderAccessMenu'
import selectListModule from './chains/selectListModule'
import showGDPRAgreement from './chains/showGDPRAgreement'
import showNewPasswordDialog from './chains/showNewPasswordDialog'
import hideNewPasswordDialog from './chains/hideNewPasswordDialog'

export default () => {
  return module => {
    module.addSignals({
      appMounted,
      redoGDRP,
      removeUserNotAgreedOnGDPRTerms,
      openListUserHeaderAccessMenu,
      closeListUserHeaderAccessMenu,
      selectListModule,
      showGDPRAgreement,
      showNewPasswordDialog,
      hideNewPasswordDialog
    })

    module.addState({
      loaded: false,
      sso: {
        hasError: false,
        retryAfterSeconds: 10
      },
      navigationOpen: false,
      showAlreadyAgreedGDPRTerms: false,
      customErrors: [],
      showUserNotAgreedOnDBPRTerms: false,
      listModule: 'account',
      listUserHeaderAccessMenuOpen: false,
      showNewPasswordDialog: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/index.js